





























import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import CheckSheetItem from '@/components/CheckSheetItem.vue';

@Component({
  components: {
    CheckSheetItem
  },
})
export default class CheckSheetGroup extends Vue {

  @Prop({
    required: true
  })
  private value: boolean

  @Prop({
    required: true
  })
  private label!: string

  @Prop({
    default: 'Check Item'
  })
  private itemHeader!: string

  @Prop({
    default: 'Condition'
  })
  private conditionHeader!: string

  @Prop({
    default: 'Deposition'
  })
  private actionHeader!: string

  @Emit()
  input(value: boolean) { }
}
